import debounce from 'lodash/debounce';
import { toggleAttribute, getWindowSize, findOffset, slideToggle } from '../helper';

// polyfills
if (typeof NodeList.prototype.forEach !== 'function') {
  NodeList.prototype.forEach = Array.prototype.forEach;
}

if (window.Element && !Element.prototype.closest) {
  Element.prototype.closest = function (s) {
    var matches = (this.document || this.ownerDocument).querySelectorAll(s),
      i,
      el = this;
    do {
      i = matches.length;
      while (--i >= 0 && matches.item(i) !== el) {}
    } while (i < 0 && (el = el.parentElement));
    return el;
  };
}

let windowWidth;
const BP_TABLET = 991;
const BP_DESKTOP = 992;

const STATE_CLOSED = 'closed';
const STATE_OPEN = 'open';
const STATE_TRUE = 'true';
const STATE_FALSE = 'false';
const STATE_HAS_CHILDREN = 'has-children';

const SELECTOR__HEADER = '.vd-section--header';
const SELECTOR__HEADER__BOTTOM = '.header__bottom';

const BODY = document.querySelector('body');
const HEADER = document.querySelector(SELECTOR__HEADER);
const MAIN_SECTION = document.querySelector('.body__container');
const HEADER_OFFSET = findOffset(HEADER);

const NAV_TOOGLE = document.querySelector('.nav-toggle');
const HEADER_BOTTOM = document.querySelector(`${SELECTOR__HEADER__BOTTOM}`);

const DD_MENUS = HEADER_BOTTOM.querySelectorAll('.vd-menu__dropdown');
const DD_CLOSE = HEADER_BOTTOM.querySelectorAll('.vd-menu__dropdown-close');
const NAV_BTN = HEADER_BOTTOM.querySelectorAll(`button.vd-menu__button[data-target*="dropdown"]`);

const SUBMENU_BTN = HEADER_BOTTOM.querySelectorAll('.vd-submenu button.vd-menu__button');
const NAV_BACK_BTN = HEADER_BOTTOM.querySelectorAll('.vd-menu__button--back');
const MAIN_NAV = HEADER_BOTTOM.querySelector('#navigation-main');

const NAV_SEARCH = document.querySelectorAll('.nav-search');
const DD_SEARCH = document.querySelector('.vd-dropdown-search');
const CLOSE_SEARCH = document.querySelector('.vd-dropdown-search__close');

/* -----------------*/

const CLASSNAME__MENU = 'vd-menu';
const CLASSNAME__MENU_ITEM = `${CLASSNAME__MENU}__item`;

const CLASSNAME__MENU_BUTTON = `${CLASSNAME__MENU}__button`;
const CLASSNAME__MENU_BUTTON__BACK = `${CLASSNAME__MENU_BUTTON}--back`;
const CLASSNAME__MENU_BUTTON__NEXT = `${CLASSNAME__MENU_BUTTON}--next`;
const CLASSNAME__MENU_BUTTON__TOP = `${CLASSNAME__MENU_BUTTON}--top`;

const CLASSNANME__MENU_DROPDOWN = `${CLASSNAME__MENU}__dropdown`;

const CLASSNAME__SUBMENU = 'vd-submenu';

const SELECTOR__MENU = `.${CLASSNAME__MENU}`;
const SELECTOR__MENU_BUTTON = `.${CLASSNAME__MENU_BUTTON}`;
const SELECTOR__MENU_BUTTON__BACK = `.${CLASSNAME__MENU_BUTTON__BACK}`;
const SELECTOR__MENU_BUTTON__NEXT = `.${CLASSNAME__MENU_BUTTON__NEXT}`;
const SELECTOR__MENU_BUTTON__TOP = `.${CLASSNAME__MENU_BUTTON__TOP}`;
const SELECTOR__MENU_ITEM = `.${CLASSNAME__MENU_ITEM}`;
const SELECTOR__MENU_ITEM_PREV = `${SELECTOR__MENU_ITEM}.back-to-parent>${SELECTOR__MENU_BUTTON__BACK}`;
const SELECTOR__MENU_ITEM_NEXT = `${SELECTOR__MENU_ITEM}.${STATE_HAS_CHILDREN}>${SELECTOR__MENU_BUTTON__NEXT}`;
const SELECTOR__MENU_DROPDOWN = `.${CLASSNANME__MENU_DROPDOWN}`;
const SELECTOR__SUBMENU = `.${CLASSNAME__SUBMENU}`;

const init = () => {
  windowWidth = getWindowSize().width;

  $(SELECTOR__HEADER__BOTTOM).removeClass(windowWidth < BP_DESKTOP ? 'desktop' : 'mobile');
  $(SELECTOR__HEADER__BOTTOM).addClass(windowWidth < BP_DESKTOP ? 'mobile' : 'desktop');
  if (isDesktop()) {
    $('body').css('overflow', 'auto');
  }
};

const fixedHeader = () => {
  let bodyScrollTop = document.documentElement.scrollTop || document.body.scrollTop;
  let delay = null;

  if (bodyScrollTop > HEADER_OFFSET.top) {
    HEADER.classList.add('fixed');
    MAIN_SECTION.classList.add('header-offset');

    delay =
      HEADER.classList.contains('fixed') &&
      window.setTimeout(() => {
        HEADER.classList.add('small');
      }, 5000);
  } else {
    if (delay) window.clearTimeout(delay);
    HEADER.classList.remove('fixed');
    HEADER.classList.remove('small');
    MAIN_SECTION.classList.remove('header-offset');
  }
};

const toggleDropdownDesktop = (e, element) => {
  if (!isDesktop) {
    return;
  }
  const el = element ? element : e.currentTarget;
  const dd = el.nextSibling;

  closeSearchDropdown();

  DD_MENUS.forEach((item) => {
    if (!item.isSameNode(dd)) item.classList.remove('show');
  });

  NAV_BTN.forEach((item) => {
    if (!item.isSameNode(el)) {
      item.setAttribute('aria-expanded', false);
      item.classList.remove('active');
    }
  });

  dd.classList.toggle('show');
  el.classList.add('active');
  toggleAttribute(el, 'aria-expanded');

  let ddIsOpen = !![...DD_MENUS].find((item) => item.classList.contains('show'));
  if (!ddIsOpen) NAV_BTN.forEach((item) => item.classList.remove('active'));
};

const isDesktop = () => {
  return windowWidth >= BP_DESKTOP;
};

const showNextLayerDesktop = (e) => {
  if (!isDesktop()) {
    return;
  }
  const el = e.currentTarget;
  const currentMenu = el.closest('.vd-submenu') || el.closest('.vd-menu');

  console.log('--- current menu ---');
  console.log(currentMenu);

  const level = Number(currentMenu.dataset.level);
  console.log(level);
  const nextMenu =
    el.nextSibling.querySelector(`.vd-submenu[data-level="${level + 1}"]`) || el.nextSibling;
  let sliderWrapper;

  const gapMobile = 30;
  const gapDesktop = 40;

  toggleAttribute(el, 'aria-expanded');

  document.querySelectorAll('.vd-submenu').forEach((item) => {
    const itemLevel = Number(item.dataset.level);
    if (itemLevel > level) item.style.display = 'none';
  });

  sliderWrapper = el.closest('.slider-wrapper-desktop');
  const translateValue = level - 1 + (currentMenu.clientWidth + gapDesktop);

  if (level === 1) {
    document.querySelectorAll('.vd-submenu').forEach((item) => (item.style.display = 'none'));
  }
  nextMenu.style.display = 'block';

  if (level % 2 === 0) {
    sliderWrapper.style.transform = `translateX(-${translateValue}px)`;
  }

  const scroller = el.closest('.vd-menu__dropdown-menu');
  scroller.scroll({
    top: 0,
    behavior: 'smooth',
  });
};

const showPrevLayerDesktop = (e) => {
  if (!isDesktop()) {
    return;
  }
  const el = e.currentTarget;
  const currentMenu = el.closest('.vd-submenu') || el.closest('.vd-menu');
  console.log(currentMenu);
  const level = Number(currentMenu.dataset.level);
  const prevMenu =
    el.closest(`.vd-menu[data-level="${level - 1}"]`) ||
    document.querySelector(`.vd-submenu[data-level="${level - 1}"]`);

  const prevActiveButton = document.querySelector(
    `button.vd-menu__button[data-target="#${currentMenu.id}"]`
  );
  let sliderWrapper;

  toggleAttribute(prevActiveButton, 'aria-expanded');

  sliderWrapper = el.closest('.slider-wrapper-desktop');

  currentMenu.style.display = 'none';
  sliderWrapper.style.transform = `translateX(${0}px)`;
};

const toggleSearchMenu = (e, button) => {
  const el = button ? button : e.currentTarget;

  closeMenuDropdownDesktop();
  slideToggle(DD_SEARCH, el);
};

const closeMenuDropdownDesktop = () => {
  if (!isDesktop()) {
    return;
  }
  DD_MENUS.forEach((item) => item.classList.remove('show'));

  NAV_BTN.forEach((item) => {
    item.setAttribute('aria-expanded', false);
    item.classList.remove('active');
  });
};

const closeSearchDropdown = () => {
  if (DD_SEARCH) {
    DD_SEARCH.classList.remove('active');
    DD_SEARCH.style.height = '0px';
  }

  NAV_SEARCH.forEach((item) => item.setAttribute('aria-expanded', false));
};

// EVENTS
window.addEventListener(
  'resize',
  debounce(() => init(), 200)
);

//window.addEventListener('scroll', () => fixedHeader());

const domReady = (cb) => {
  document.readyState === 'interactive' || document.readyState === 'complete'
    ? cb()
    : document.addEventListener('DOMContentLoaded', cb);
};
domReady(() => {
  setTimeout(() => {
    init__onReady();
  }, 250);
  init();
});

const init__onReady = () => {
  NAV_BTN.forEach((item) =>
    item.addEventListener('click', (event) => toggleDropdownDesktop(event))
  );
  SUBMENU_BTN.forEach((item) =>
    item.addEventListener('click', (event) => showNextLayerDesktop(event))
  );
  NAV_BACK_BTN.forEach((item) =>
    item.addEventListener('click', (event) => showPrevLayerDesktop(event))
  );
  if (DD_MENUS.length > 0) {
    DD_MENUS[DD_MENUS.length - 1]
      .querySelector('.vd-menu__dropdown-close')
      .addEventListener('focusout', (event) => {
        const activeMenuButton = document.querySelector('.vd-button--menu.top.active');
        toggleDropdownDesktop(event, activeMenuButton);
      });
  }
  DD_CLOSE.forEach((item) =>
    item.addEventListener('click', (event) => {
      const activeMenuButton = document.querySelector('.vd-button--menu.top.active');
      toggleDropdownDesktop(event, activeMenuButton);
    })
  );

  if (typeof CLOSE_SEARCH !== 'undefined') {
    NAV_SEARCH.forEach((item) => {
      item.addEventListener('click', (event) => toggleSearchMenu(event));
      CLOSE_SEARCH.addEventListener('click', (event) => toggleSearchMenu(null, item));
    });
  }

  window.addEventListener('keydown', (event) => {
    const activeMenuButton = document.querySelector('.vd-button--menu.top.active');
    if (event.key === 'Escape' && activeMenuButton) {
      toggleDropdownDesktop(event, activeMenuButton);
    } else {
      return null;
    }
  });
};
